import { useState } from "react";
import IconButtonAnimate from "src/components/animate/IconButtonAnimate";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import LanguageImage from "./LanguageImage";
import Menu from "./Menu";

// ----------------------------------------------------------------------

export default function LanguagePopover() {
	const [open, setOpen] = useState<HTMLElement | null>(null);

	const isDesktop = useResponsive("up", "lg");
	const { currentLang } = useLocales();

	const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
		setOpen(event.currentTarget);
	};

	const handleClose = () => {
		setOpen(null);
	};

	return (
		<>
			<IconButtonAnimate
				onClick={handleOpen}
				sx={{
					ml: !isDesktop ? 0 : 2,
					width: 40,
					height: 40,
					...(open && { bgcolor: "action.selected" })
				}}
			>
				<LanguageImage url={currentLang.icon} />
			</IconButtonAnimate>
			<Menu onClose={handleClose} open={open} />
		</>
	);
}
